const ajuda = angular.module('ajuda', [])

ajuda.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.ajuda',
            url: '/ajuda',
            params: { showGlobalLoading: { dynamic: true, value: true }, showAjuda: true },
            component: 'ajuda.ajudaComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);